export type YearEndFlashSaleRotation = {
  startDate: string;
  endDate: string;
  collectionName: string;
  campaignUrl: string;
};

/**
 * Year End Flash Sale rotation schedule
 * All times are in SGT (Asia/Singapore timezone)
 * Format: 'YYYY-MM-DD HH:mm:ss'
 */
export const YEAR_END_FLASH_SALE_ROTATIONS: YearEndFlashSaleRotation[] = [
  {
    startDate: '2025-11-24 15:00:00',
    endDate: '2025-11-26 15:00:00',
    collectionName: 'Year End Flash Sale 1',
    campaignUrl: '/campaign/black-friday/',
  },
  {
    startDate: '2025-11-26 15:00:00',
    endDate: '2025-11-27 15:00:00',
    collectionName: 'Year End Flash Sale 2',
    campaignUrl: '/campaign/black-friday/',
  },
  {
    startDate: '2025-11-27 15:00:00',
    endDate: '2025-11-28 15:00:00',
    collectionName: 'Year End Flash Sale 3',
    campaignUrl: '/campaign/black-friday/',
  },
  {
    startDate: '2025-11-28 15:00:00',
    endDate: '2025-11-29 15:00:00',
    collectionName: 'Year End Flash Sale 4',
    campaignUrl: '/campaign/black-friday/',
  },
  {
    startDate: '2025-11-29 15:00:00',
    endDate: '2025-11-30 15:00:00',
    collectionName: 'Year End Flash Sale 5',
    campaignUrl: '/campaign/black-friday/',
  },
  {
    startDate: '2025-11-30 15:00:00',
    endDate: '2025-12-01 08:00:00',
    collectionName: 'Year End Flash Sale 1',
    campaignUrl: '/campaign/black-friday/',
  },
  {
    startDate: '2025-12-01 08:00:00',
    endDate: '2025-12-02 15:00:00',
    collectionName: 'Year End Flash Sale 2',
    campaignUrl: '/campaign/cyber-monday/',
  },
  {
    startDate: '2025-12-02 15:00:00',
    endDate: '2025-12-03 15:00:00',
    collectionName: 'Year End Flash Sale 3',
    campaignUrl: '/campaign/cyber-monday/',
  },
  {
    startDate: '2025-12-19 15:00:00',
    endDate: '2025-12-20 15:00:00',
    collectionName: 'Year End Flash Sale 4',
    campaignUrl: '/campaign/christmas/',
  },
  {
    startDate: '2025-12-20 15:00:00',
    endDate: '2025-12-21 15:00:00',
    collectionName: 'Year End Flash Sale 5',
    campaignUrl: '/campaign/christmas/',
  },
  {
    startDate: '2025-12-21 15:00:00',
    endDate: '2025-12-22 15:00:00',
    collectionName: 'Year End Flash Sale 1',
    campaignUrl: '/campaign/christmas/',
  },
  {
    startDate: '2025-12-22 15:00:00',
    endDate: '2025-12-23 15:00:00',
    collectionName: 'Year End Flash Sale 2',
    campaignUrl: '/campaign/christmas/',
  },
  {
    startDate: '2025-12-23 15:00:00',
    endDate: '2025-12-24 15:00:00',
    collectionName: 'Year End Flash Sale 3',
    campaignUrl: '/campaign/christmas/',
  },
  {
    startDate: '2025-12-24 15:00:00',
    endDate: '2025-12-25 15:00:00',
    collectionName: 'Year End Flash Sale 4',
    campaignUrl: '/campaign/christmas/',
  },
  {
    startDate: '2025-12-25 15:00:00',
    endDate: '2025-12-26 15:00:00',
    collectionName: 'Year End Flash Sale 5',
    campaignUrl: '/campaign/christmas/',
  },
  {
    startDate: '2025-12-26 15:00:00',
    endDate: '2025-12-27 15:00:00',
    collectionName: 'Year End Flash Sale 1',
    campaignUrl: '/campaign/new-year/',
  },
  {
    startDate: '2025-12-27 15:00:00',
    endDate: '2025-12-28 15:00:00',
    collectionName: 'Year End Flash Sale 2',
    campaignUrl: '/campaign/new-year/',
  },
  {
    startDate: '2025-12-28 15:00:00',
    endDate: '2025-12-29 15:00:00',
    collectionName: 'Year End Flash Sale 3',
    campaignUrl: '/campaign/new-year/',
  },
  {
    startDate: '2025-12-29 15:00:00',
    endDate: '2025-12-30 15:00:00',
    collectionName: 'Year End Flash Sale 4',
    campaignUrl: '/campaign/new-year/',
  },
  {
    startDate: '2025-12-30 15:00:00',
    endDate: '2025-12-31 15:00:00',
    collectionName: 'Year End Flash Sale 5',
    campaignUrl: '/campaign/new-year/',
  },
  {
    startDate: '2025-12-31 15:00:00',
    endDate: '2026-01-01 15:00:00',
    collectionName: 'Year End Flash Sale 1',
    campaignUrl: '/campaign/new-year/',
  },
  {
    startDate: '2026-01-01 15:00:00',
    endDate: '2026-01-02 15:00:00',
    collectionName: 'Year End Flash Sale 2',
    campaignUrl: '/campaign/new-year/',
  },
];

export const YEAR_END_FLASH_SALE_TIMEZONE = 'Asia/Singapore';
